<mat-card appearance="outlined" *ngIf="!simpleView">
  <mat-card-title *ngIf="title" class="section__file__upload__title" [innerHTML]="title"></mat-card-title>
  <mat-card-subtitle [innerHTML]="subTitle"></mat-card-subtitle>
  <ng-container *ngTemplateOutlet="bodyFileComponent"></ng-container>
</mat-card>
<div *ngIf="simpleView">
  <ng-container *ngTemplateOutlet="bodyFileComponent"></ng-container>
</div>
<!-- template component -->
<ng-template #bodyFileComponent>
  <div fxLayout="row" class="mat-elevation-z2">
    <mat-progress-bar
      *ngIf="uploadFiles && uploadFiles.length > 0"
      [mode]="uploadTotal.state == 'PENDING' ? 'buffer' : 'determinate'"
      [value]="uploadTotal.progress"
    ></mat-progress-bar>
  </div>
  <mat-card-actions align="{{buttonIconAlign}}">
    <div fxLayout="row">
      <p8-attachment-upload
        *ngFor="let file of attachments; trackBy: trackByFn; let idx = index"
        [attachment]="file"
        (onDestroy)="childDestroy($event)"
        [launchSignal]="launcher"
        (onFinished)="collectFiles($event)"
        (onProgress)="progressFile($event, idx)"
        [maxFileSize]="maxFileSize">
      </p8-attachment-upload>
      <input hidden
             type="file"
             #fileInput
             name="fileInput"
             [accept]="accept"
             (change)="prepareAttachmentsToUpload($event)">
      <button *ngIf="canShowButton()"
              mat-button
              [disabled]="isButtonDisabled()"
              [ngClass]="typeButton === 'label' ?  'mat-raised-button' : 'mat-icon-button'"
              color="{{colorButton}}"
              matTooltip="{{labelJoin}}"
              (click)="fileInput.click()">
        <span *ngIf="typeButton === 'label'">{{labelJoin}}</span>
        <mat-icon>{{buttonSelectIcon}}</mat-icon>
      </button>
    </div>
  </mat-card-actions>
</ng-template>


